import styled from "styled-components";
import { fromLonLat } from "ol/proj";
import { Layers, BasemapLayer, VectorLayer, GraticuleLayer } from "./Map/Layers";
import {
  Controls, FullScreenControl, GraticuleControl, ZoomControl, ZoomToExtentControl,
  ScaleLineControl, OverviewMapControl, AttributionControl,
  MeasureControl, IdentifyControl, DrawingControl
} from "./Map/Controls";
import { Interactions, DrawBbox } from "./Map/Interactions";

import Map from "./Map";
import ZoomToMap from './Map/ZoomToMap';
import PopUp from './Map/PopUp';
import { vector } from "./Map/Source"
import { Button, ButtonGroup, IconButton, Checkbox } from "@mui/material";
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';

import { Close, ExpandLess, ExpandMore, LayersRounded, Print as PrintIcon } from "@mui/icons-material";
import { useRef, useState, useEffect } from "react";

import Basemap from './Map/Basemap';
import Layer from './Map/Layer';
//import List from './Map/List';

//import Print from './Map/Print/Print';
//import BoundaryLayer from "./Map/Layers/BoundaryLayer";
//import BBoxLayer from "./Map/Layers/BBoxLayer";
import IndikatorLayer from "./Map/Layers/IndikatorLayer";
import GroupLayer from "./Map/Layers/GroupLayer";
/*

import StatisticLayer from "./Map/Layers/StatisticLayer";



*/
import BatasProvinsiLayer from "./Map/Layers/BatasProvinsiLayer";
import BatasKabupatenLayer from "./Map/Layers/BatasKabupatenLayer";
import BatasKecamatanLayer from "./Map/Layers/BatasKecamatanLayer";
import BatasDesaLayer from "./Map/Layers/BatasDesaLayer";

import KabupatenLayer from "./Map/Layers/KabupatenLayer";
import KecamatanLayer from "./Map/Layers/KecamatanLayer";
import DesaLayer from "./Map/Layers/DesaLayer";
import BNBALayer from "./Map/Layers/BNBALayer";


//import AnalysisLayer from "./Map/Layers/AnalysisLayer";
import IdentifyLayer from "./Map/Layers/IdentifyLayer";
import { ImageWMS as ImageWMSSource } from 'ol/source';
import Config from '../config.json';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';


const listIndikator = [
  { id: 1, label: 'Prevalensi Stunting', field:'PREVSTUNT', layer: 'prev_stunt', provinsi: true, kabupaten: true, kecamatan: false, desa: false, bnba: false },
  //{ id: 2, label: 'Prevalensi Wasted', layer: 'prev_wasted', provinsi: true, kabupaten: true, kecamatan: false, desa: false, bnba: false },
  { id: 2, label: 'Persentase Keluarga dengan Anak Usia 0-23 Bulan', field:'PREVSTUNT', layer: 'bln_0_23n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 3, label: 'Persentase Keluarga dengan Anak Usia Balita', field:'PREVSTUNT', layer: 'balitan', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 4, label: 'Persentase Keluarga Beresiko Stunting', field:'PREVSTUNT', layer: 'riskn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true, },
  { id: 5, label: 'Persentase PUS Hamil', field:'PREVSTUNT', layer: 'pushmln', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 6, label: 'Persentase Keluarga Sasaran Memiliki Jamban Tidak Layak', field:'PREVSTUNT', layer: 'jmbnlykbn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 7, label: 'Persentase Keluarga Sasaran Memiliki Sumber Air Minum Tidak Layak', field:'PREVSTUNT',layer: 'smbairbn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 8, label: 'Presentase PUS Terlalu Muda', field:'PREVSTUNT', layer: 'tll_mudan', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 9, label: 'Presentase PUS Terlalu Tua', field:'PREVSTUNT', layer: 'tll_tuan', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 10, label: 'Presentase PUS Terlalu Dekat', field:'PREVSTUNT', layer: 'tll_dktn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 11, label: 'Presentase PUS Terlalu Banyak', field:'PREVSTUNT', layer: 'tll_bnykn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 12, label: 'Persentase Keluarga Berpartisipasi KB', field:'PREVSTUNT', layer: 'kbn', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 13, label: 'Persentase Keluarga Berisiko 0', field:'PREVSTUNT', layer: 'risk0n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 14, label: 'Persentase Keluarga Berisiko 1', field:'PREVSTUNT', layer: 'risk1n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 15, label: 'Persentase Keluarga Berisiko 2', field:'PREVSTUNT', layer: 'risk2n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 16, label: 'Persentase Keluarga Berisiko 3', field:'PREVSTUNT', layer: 'risk3n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true },
  { id: 17, label: 'Persentase Keluarga Berisiko 4', field:'PREVSTUNT', layer: 'risk4n', provinsi: true, kabupaten: true, kecamatan: true, desa: true, bnba: true }

]

export default function MapContainer({ center, zoom, basemap, setBasemap, bbox, visibleBbox,
  boundary, visibleBoundary, zoomBbox, setZoomBbox, drawing, setBbox, setDrawing, setVisibleBbox,
  setLabelArea, mapLayer, visibleAnalysis, buffered, setMapLayer,  identifierDelete, setIdentifierDelete,
  list

}) {
  const basemapRef = useRef();

  const [showBasemap, setShowBasemap] = useState(false);
  const [showLayer, setShowLayer] = useState(false);
  const [showIndikator, setShowIndikator] = useState(true);
  const [showStudyArea, setShowStudyArea] = useState(false);
  const [showLegenda, setShowLegenda] = useState(false);
  const [showAnalysis, setShowAnalysis] = useState(false);
  const [showMeasurement, setShowMeasurement] = useState(false);
  const [showInformation, setShowInformation] = useState(false);
  const [showDiagram, setShowDiagram] = useState(false);
  const [showProvinsi, setShowProvinsi] = useState(false);
  const [showKabupaten, setShowKabupaten] = useState(false);
  const [showKecamatan, setShowKecamatan] = useState(false);
  const [showDesa, setShowDesa] = useState(false);
  const [showBNBA, setShowBNBA] = useState(false);
  const [showPrint, setShowPrint] = useState(false);

  const [visibleBatasProvinsi, setVisibleBatasProvinsi] = useState(false);
  const [visibleBatasKabupaten, setVisibleBatasKabupaten] = useState(false);
  const [visibleBatasKecamatan, setVisibleBatasKecamatan] = useState(false);
  const [visibleBatasDesa, setVisibleBatasDesa] = useState(false);

  const [collapsedIndikator, setCollapsedIndikator] = useState(false);
  const [collapsedStudyArea, setCollapsedStudyArea] = useState(false);
  const [collapsedLegenda, setCollapsedLegenda] = useState(false);
  const [collapsedInformation, setCollapsedInformation] = useState(false);
  const [collapsedDiagram, setCollapsedDiagram] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [batasCollapsed, setBatasCollapsed] = useState(false);

  const [idProvince, setIdProvince] = useState(0);
  const [labelProvince, setLabelProvince] = useState('');
  const [idMunicipal, setIdMunicipal] = useState(0);
  const [labelMunicipal, setLabelMunicipal] = useState('');
  const [idKecamatan, setIdKecamatan] = useState(0);
  const [labelKecamatan, setLabelKecamatan] = useState('');
  const [idDesa, setIdDesa] = useState(0);
  const [labelDesa, setLabelDesa] = useState('');

  const [listCountries, setListCountries] = useState();
  const [listProvinces, setListProvinces] = useState();
  const [listMunicipals, setListMunicipals] = useState();
  const [listKecamatan, setListKecamatan] = useState();
  const [listDesa, setListDesa] = useState();
  const [listMunicipalsA, setListMunicipalsA] = useState();
  const [listKecamatanA, setListKecamatanA] = useState();
  const [listDesaA, setListDesaA] = useState();

  const [zoomToMap, setZoomToMap] = useState();

  const [value, setValue] = useState("");
  const [show, setShow] = useState(false);
  const [flag, setFlag] = useState(false);

  const [coordinate, setCoordinate] = useState();
  const [url, setUrl] = useState("");
  const [content, setContent] = useState();

  const [idIndikator, setIdIndikator] = useState(0);
  const [infoLabelIndikator, setInfoLabelIndikator] = useState("Belum ada indikator yang dipilih");
  const [listIndikatorAktif, setListIndikatorAktif] = useState([]);

  const [layer, setLayer] = useState("dashboard%3Aprovinsi_pk2022");
  const [level, setLevel] = useState("negara");// negara | provinsi | kabkot | kecamatan | desa
  const [kode, setKode] = useState(0);
  const [infoLabelWilayah, setInfoLabelWilayah] = useState("Indonesia");

  const iconIndikator = collapsedIndikator ? <ExpandMore fontSize="small" /> : <ExpandLess fontSize="small" />
  const iconStudyArea = collapsedStudyArea ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />
  const iconLegenda = collapsedLegenda ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />
  const iconInformation = collapsedInformation ? <ExpandMore fontSize="small" /> : <ExpandLess fontSize="small" />
  const iconDiagram = collapsedDiagram ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />
  const icon = collapsed ? <ExpandMore fontSize="small" /> : <ExpandLess fontSize="small" />
  const iconBatas = batasCollapsed ? <ExpandMore fontSize="small" /> : <ExpandLess fontSize="small" />

  function closeMenu() {
    var legendContainer = document.getElementById('legendContainer');
    var legendContent = document.getElementById('legendContent');
    if (collapsed) {
      legendContainer.style.width = "200px";
      legendContainer.style.height = "200px";
      setCollapsed(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "95px";
      legendContainer.style.height = "30px";
      setCollapsed(true);
      legendContent.style.display = 'none';
    }

  }


  
  function closeBatas() {
    var legendContainer = document.getElementById('batasContainer');
    var legendContent = document.getElementById('batasContent');
    if (batasCollapsed) {
      legendContainer.style.width = "200px";
      legendContainer.style.height = "250px";
      setBatasCollapsed(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "200px";
      legendContainer.style.height = "30px";
      setBatasCollapsed(true);
      legendContent.style.display = 'none';
    }

  }


  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: "170"
    },
    title: {
      text: 'Jumlah Keluarga Resiko Stunting',
      style: { "color": "#333333", "fontSize": "12px" }
      /*
      align: 'center',
      verticalAlign: 'middle',
      y: 60
      */
    },
    legend: {
      layout: 'vertical',
      backgroundColor: '#FFFFFF',
      align: 'right',
      verticalAlign: 'top',
      floating: true,
      x: 20,
      y: 45
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'white'
          }
        },
        startAngle: 0,
        endAngle: 360,
        center: ['25%', '50%'],
        size: '120%',
        showInLegend: true
      }
    },
    series: [{
      type: 'pie',
      name: 'Kasus',
      innerSize: '30%',
      data: [
        ['Tidak Signifikan', 25.0],
        ['Klaster Tinggi', 8.0],
        ['Klaster Rendah', 12.0],
      ]
    }]
  };
  function load_kabupaten53() {
    var kabupatenSet = [{ id: 0, province: 0, name: "Semua" }];
       setListMunicipals(kabupatenSet)
    console.log('municipals done')
  }

  function load_kecamatan() {
    var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
    setListKecamatan(kecamatanSet)
    console.log('kecamatan done')
  
  }
  function load_desa() {
    var dataSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
    
    setListDesa(dataSet)
    console.log('desa done')
  }
  function test_indikator() {
    var tampung;

    if (level === "negara")
      tampung = listIndikator.filter(item => item.provinsi === true)
    else if (level === "provinsi")
      tampung = listIndikator.filter(item => item.kabupaten === true)
    else if (level === "kabkot")
      tampung = listIndikator.filter(item => item.kecamatan === true)
    else if (level === "kecamatan")
      tampung = listIndikator.filter(item => item.desa === true)
    else if (level === "desa")
      tampung = listIndikator.filter(item => item.bnba === true)

    var tes = tampung.filter(item => item.id === idIndikator)
    return tes.length
  }

  useEffect(() => {

    if (idIndikator > 0) {
      var tes = test_indikator()
      console.log(idIndikator)
      if (tes == 0) {

        setValue()
        setTimeout(function () {
          alert('Indikator yang aktif tidak tersedia pada level administrasi saat ini. Silahkan pilih Indikator lain')
        }, 500)

      }
    }
  }, [idIndikator, level]);

  useEffect(() => {
    //alert('indikator')


    if (level === "negara") {
      //setIdProvince(kode);
      setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
      setInfoLabelWilayah("Indonesia")
      if (layer) {
        setUrl('./data/provinsi/provinsi_stats.geojson')
      }
      //if(idProvince === 0)
      //setUrl('./data/provinsi/provinsi_stats.geojson')
    } else if (level === "provinsi") {
      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
      setUrl('./data/kabupaten/' + idProvince + '.geojson')
      console.log(idProvince)
      var raw = listProvinces.filter(x => x.id == idProvince)
      console.log(listProvinces)
      console.log(raw)
      setInfoLabelWilayah("Provinsi " + raw[0].name)
      setListMunicipalsA(listMunicipals)
    } else if (level === "kabkot") {

      setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
      setUrl('./data/kecamatan/' + idMunicipal + '.geojson')
      var raw = listMunicipals.filter(x => x.id === idMunicipal)
      setInfoLabelWilayah(raw[0].name.includes("Kota ") ? raw[0].name : "Kabupaten " + raw[0].name)
      //load kecamatan
      setListKecamatanA(listKecamatan.filter(x => x.kabupaten === 0 || x.kabupaten === idMunicipal))
    } else if (level === "kecamatan") {
      setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
      setUrl('./data/desa/' + idKecamatan + '.geojson')
      var raw = listKecamatan.filter(x => x.id === idKecamatan)
      setInfoLabelWilayah("Kecamatan " + raw ? raw[0].name : "")
      setListDesaA(listDesa.filter(x => x.kecamatan === 0 || x.kecamatan === idKecamatan))
    } else if (level === "desa") {
      setListIndikatorAktif(listIndikator.filter(item => item.bnba === true))
      setUrl('./data/bnba/' + idDesa + '_pt.geojson')
      var raw = listDesa.filter(x => x.id === idDesa)
      setInfoLabelWilayah("Desa " + raw[0].name)
    }


  }, [level]);
  /*
  useEffect(() => {
    if (idKecamatan !== 0) {
      setIdDesa(0)
      setListDesaA(listDesa.filter(x => x.kecamatan === 0 || x.kecamatan === idKecamatan))
    }
  }, [idKecamatan]);
  */

  useEffect(() => {
    setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
    load_kabupaten53()
    load_kecamatan()
    load_desa()
    var dataset = [{ id: 0, name: "Semua" }]

    dataset.push({ id: 11, name: "Aceh" });
    dataset.push({ id: 51, name: "Bali" });
    dataset.push({ id: 36, name: "Banten" });
    dataset.push({ id: 17, name: "Bengkulu" });
    dataset.push({ id: 34, name: "DI Yogyakarta" });
    dataset.push({ id: 31, name: "DKI Jakarta" });
    dataset.push({ id: 75, name: "Gorontalo" });
    dataset.push({ id: 15, name: "Jambi" });
    dataset.push({ id: 32, name: "Jawa Barat" });
    dataset.push({ id: 33, name: "Jawa Tengah" });
    dataset.push({ id: 35, name: "Jawa Timur" });
    dataset.push({ id: 61, name: "Kalimantan Barat" });
    dataset.push({ id: 63, name: "Kalimantan Selatan" });
    dataset.push({ id: 62, name: "Kalimantan Tengah" });
    dataset.push({ id: 64, name: "Kalimantan Timur" });
    dataset.push({ id: 65, name: "Kalimantan Utara" });
    dataset.push({ id: 19, name: "Kep. Bangka Belitung" });
    dataset.push({ id: 21, name: "Kep. Riau" });
    dataset.push({ id: 18, name: "Lampung" });
    dataset.push({ id: 81, name: "Maluku" });
    dataset.push({ id: 82, name: "Maluku Utara" });
    dataset.push({ id: 52, name: "Nusa Tenggara Barat" });
    dataset.push({ id: 53, name: "Nusa Tenggara Timur" });
    dataset.push({ id: 91, name: "Papua" });
    dataset.push({ id: 92, name: "Papua Barat" });
    dataset.push({ id: 14, name: "Riau" });
    dataset.push({ id: 76, name: "Sulawesi Barat" });
    dataset.push({ id: 73, name: "Sulawesi Selatan" });
    dataset.push({ id: 72, name: "Sulawesi Tengah" });
    dataset.push({ id: 74, name: "Sulawesi Tenggara" });
    dataset.push({ id: 71, name: "Sulawesi Utara" });
    dataset.push({ id: 13, name: "Sumatera Barat" });
    dataset.push({ id: 16, name: "Sumatera Selatan" });
    dataset.push({ id: 12, name: "Sumatera Utara" });
    setListProvinces(dataset)

    setIdMunicipal(0);
    var kabupatenSet = [{ id: 0, province: 0, name: "Semua" }];
    setListMunicipalsA(kabupatenSet)

    setIdKecamatan(0);
    var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
    setListKecamatanA(kecamatanSet)

    setIdDesa(0);
    var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
    setListDesaA(desaSet)



  }, []);

  function getProvinces() {
    if (typeof (listProvinces) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listProvinces !== null) {
        if (listProvinces.length > 0) {
          return listProvinces.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  function getMunicipals() {
    if (typeof (listMunicipalsA) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listMunicipalsA !== null) {
        if (listMunicipalsA.length > 0) {
          return listMunicipalsA.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }
  function getKecamatan() {
    if (typeof (listKecamatanA) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listKecamatanA !== null) {
        if (listKecamatanA.length > 0) {
          return listKecamatanA.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }
  function getDesa() {
    if (typeof (listDesaA) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listDesaA !== null) {
        if (listDesaA.length > 0) {
          return listDesaA.map((row, index) => {
            //console.log(row.id, index)
            return (<MenuItem key={index} value={row.id}>
              {row.name}
            </MenuItem>
            )
          })
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }
  function handleCloseBasemap(e) {
    setShowBasemap(false);
  }

  function handleCloseLayer() {
    setShowLayer(false)
  }

  function handleCloseIndikator() {
    setShowIndikator(false)
  }

  function handleClosePrint(e) {
    setShowPrint(false);
  }


  //const handleChangeSelect = (event) => {
  // setIdProvince(event.target.value);
  //};

  //const handleChange = (event, newValue) => {
  // setValue(newValue);
  // };



  function deleteDataset(id) {
    //setDataset(oldArray => [...oldArray, newElement]);
    //console.log(dataset);

    const layers = mapLayer.slice();
    console.log(id);

    //console.log(map)
    //map.eachLayer(function(layer){
    //if(layer.options.id === id)
    //map.removeLayer(layer)
    //});
    //var index = mapLayer.findIndex(x => x.id === id);
    //setDataset(mapLayer.slice(index, 1));
    //console.log(typeof(id))
    //console.log(typeof(dataset.slice()[0].id))
    //console.log(dataset.filter(item => item.id !== id))
    setMapLayer(mapLayer.filter(item => item.id !== id));
    setIdentifierDelete(id)

  }

  function handleVisible(id) {
    //setIdentifierVisible(id);
    const data = mapLayer.slice();
    //console.log(data[0]);
    var index = mapLayer.findIndex(x => x.id === id);
    //console.log(index);
    data[index].visible = !data[index].visible
    setMapLayer(data);
  }

  function handleOpacity(id, val) {
    //console.log(id, val)
    //setIdentifierVisible(id);
    const data = mapLayer.slice();
    //console.log(data[0]);
    var index = mapLayer.findIndex(x => x.id === id);
    //console.log(index);
    data[index].opacity = val
    setMapLayer(data);
  }
  const handleChangeProvinces = (event) => {
    //setIdCountry(event.target.value);
    setIdProvince(event.target.value);
    setKode(event.target.value);
    //console.log(event.target);

    var raw = listProvinces.filter(x => x.id === event.target.value)
    //console.log(event.target.value);

    setLabelProvince(raw[0].name);
    if (event.target.value === 0) {

      setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
      setIdMunicipal(0);
      var kabupatenSet = [{ id: 0, province: 0, name: "Semua" }];
      setListMunicipalsA(kabupatenSet)

      setIdKecamatan(0);
      var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
      setListKecamatanA(kecamatanSet)
      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
    } else if (event.target.value === 12) {
      //alert ('Generate Regions')
      setIdMunicipal(0);
      setListMunicipalsA(listMunicipals)
      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
    }
  };


  const handleChangeMunicipal = (event) => {

    setIdMunicipal(event.target.value);
    setKode(event.target.value);
    var raw = listMunicipals.filter(x => x.id === event.target.value)
    //console.log(event.target.value);

    setLabelMunicipal(raw[0].name);
    if (event.target.value === 0) {
      //setLocalLabelArea(labelCountry + "/" + labelProvince)

      setIdKecamatan(0);
      var kecamatanSet = [{ id: 0, kabupaten: 0, name: "Semua" }];
      setListKecamatanA(kecamatanSet)

      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))

    } else {
      setIdKecamatan(0);
      setListKecamatanA(listKecamatan.filter(x => x.kabupaten === 0 || x.kabupaten === event.target.value))

      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
      setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
    }

  };


  const handleChangeKecamatan = (event) => {

    console.log(event.target.value)
    setIdKecamatan(event.target.value);
    setKode(event.target.value);
    var raw = listKecamatan.filter(x => x.id === event.target.value)
    //console.log(event.target.value);

    setLabelKecamatan(raw[0].name);
    if (event.target.value === 0) {
      //setLocalLabelArea(labelCountry + "/" + labelProvince)
      setIdDesa(0);
      var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
      setListDesaA(desaSet)
      setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
    } else {
      //alert ('Generate Regions')
      //setLocalLabelArea(labelCountry + "/" + labelProvince + "/" + raw[0].name)
      setIdDesa(0)
      setListDesaA(listDesa.filter(x => x.kecamatan === 0 || x.kecamatan === event.target.value))
      setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
    }

  };



  const handleChangeDesa = (event) => {
    //setIdDesa(0);
    //var desaSet = [{ id: 0, kecamatan: 0, name: "Semua" }];
    //setListDesaA(desaSet)
    //setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))

    setIdDesa(event.target.value);
    setKode(event.target.value);
    var raw = listDesa.filter(x => x.id === event.target.value)
    setLabelDesa(raw[0].name);
    if (event.target.value === 0) {
      setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
    } else {
      setListIndikatorAktif(listIndikator.filter(item => item.bnba === true))
    }


  };


  const handleMenuIndikator = () => {
    setShowIndikator(!showIndikator)
    if (collapsedIndikator)
      setCollapsedIndikator(false)
  };

  const handleMenuStudyArea = () => {
    setShowStudyArea(!showStudyArea)
    if (collapsedStudyArea)
      setCollapsedStudyArea(false)
  };
  const handleMenuLegenda = () => {
    setShowLegenda(!showLegenda)
    if (collapsedLegenda)
      setCollapsedLegenda(false)
  };
  const handleMenuInformation = () => {
    setShowInformation(!showInformation)
    if (collapsedInformation)
      setCollapsedInformation(false)
  };
  const handleMenuDiagram = () => {
    setShowDiagram(!showDiagram)
    if (collapsedDiagram)
      setCollapsedDiagram(false)
  };

  function handlingIndikator() {
    setShow(false)
    if (value) {
      setIdIndikator(value.id)
      setInfoLabelIndikator(value.label)
      setShowLegenda(true)
      setShowStudyArea(true)
      setLayer(value.layer)
      if (idProvince > 0) {
        if (idMunicipal !== 0) {
          if (idKecamatan !== 0) {
            if (idDesa !== 0) {
              setLevel("desa")
            } else {
              setLevel("kecamatan")
            }

          } else {
            setLevel("kabkot")
          }
        } else {
          setLevel("provinsi")
        }
      } else {
        setLevel("negara")
        setUrl('./data/provinsi/provinsi_stats.geojson')
      }

    } else {
      setIdIndikator(0)
      setInfoLabelIndikator("Belum ada indikator yang dipilih")
      setShowLegenda(false)
      setShowStudyArea(false)
      setLayer("")
      setUrl("")
    }
    /*
    if (value) {
      setShowProvinsi(false)
      setShowKabupaten(false)
      setShowKecamatan(false)
      setShowDesa(false)
      setShowBNBA(false)
      setIdIndikator(value.id)
      setInfoLabelIndikator(value.label)
      loadPeta(value)
      setShowLegenda(true)
    } else {
      setIdIndikator(0)
      setInfoLabelIndikator("Belum ada indikator yang dipilih")
      setShowProvinsi(false)
    }
    */
  }
  /*
  function loadPeta(row) {
    //console.log(row.id)
    setLayer(row.layer)
    if (idProvince > 0) {
      setShowProvinsi(false)
      if (idMunicipal > 0) {
        setShowKabupaten(false)
      } else {
        setShowKabupaten(true)
      }
    } else {
      setShowProvinsi(true)
    }

  }
  */
  function handlingRefine() {
    setShow(false)
    if (idProvince > 0) {
      if (idMunicipal !== 0) {
        if (idKecamatan !== 0) {
          if (idDesa !== 0) {
            setLevel("desa")
            var raw = listDesa.filter(x => x.id === idDesa)
            setInfoLabelWilayah("Desa " + raw[0].name)
            setUrl('./data/bnba/' + idDesa + '_pt.geojson')
          } else {
            setLevel("kecamatan")
            var raw = listKecamatan.filter(x => x.id === idKecamatan)
            setInfoLabelWilayah("Kecamatan " + raw[0].name)
            setUrl('./data/desa/' + idKecamatan + '.geojson')
          }
        } else {
          setLevel("kabkot")
          var raw = listMunicipals.filter(x => x.id === idMunicipal)
          setInfoLabelWilayah(raw[0].name.includes("Kota ") ? raw[0].name : "Kabupaten " + raw[0].name)
          setUrl('./data/kecamatan/' + idMunicipal + '.geojson')
        }
      } else {
        setLevel("provinsi")
        var raw = listProvinces.filter(x => x.id === idProvince)
        setInfoLabelWilayah("Provinsi " + raw[0].name)
        setUrl('./data/kabupaten/' + idProvince + '.geojson')
        setZoomToMap(idProvince)
      }
    } else {
      setLevel("negara")
      setInfoLabelWilayah("Indonesia")
      if (layer) {
        setUrl('./data/provinsi/provinsi_stats.geojson')
      }
    }
    /*

      setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
      setUrl('./data/kabupaten/' + idProvince + '.geojson')
      var raw = listProvinces.filter(x => x.id === idProvince)
      setInfoLabelWilayah("Provinsi " + raw[0].name)
      setListMunicipalsA(listMunicipals)


    if (idIndikator > 0) {
      if (idProvince > 0) {
        //setZoomToMap([[[,],[13238952.748806197,],[13936426.68813236,-900586.487496253],[13936426.68813236,-1232970.377072403],[13238952.748806197,-1232970.377072403]]])

        if (idProvince == 53 && idMunicipal == 0) {
          var coord = []
          var xmin = coord[0]
          var ymin = coord[1]
          var xmax = coord[2]
          var ymax = coord[3]
          setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
        }
        if (idMunicipal > 0) {
          if (idMunicipal == 438 && idKecamatan == 0) {
            var coord = [13798870, -1140288, 13904091, -1057675]
            var xmin = coord[0]
            var ymin = coord[1]
            var xmax = coord[2]
            var ymax = coord[3]
            setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
          }
          if (idKecamatan > 0) {
            if (idKecamatan == 520 && idDesa == 0) {
              var coord = [13817608, -1111906, 13842753, -1094275]
              var xmin = coord[0]
              var ymin = coord[1]
              var xmax = coord[2]
              var ymax = coord[3]
              setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
            }
            if (idDesa > 0) {
              if (idDesa == 603) {
                var coord = [13827119,-1105042, 13834941,-1100044]
                var xmin = coord[0]
                var ymin = coord[1]
                var xmax = coord[2]
                var ymax = coord[3]
                setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
              }
              setInfoLabelWilayah(labelDesa)
              setListIndikatorAktif(listIndikator.filter(item => item.bnba === true))
              setShowProvinsi(false)
              setShowKabupaten(false)
              setShowKecamatan(false)
              setShowDesa(false)
              setShowBNBA(true)
            } else {
              setInfoLabelWilayah(labelKecamatan)
              setListIndikatorAktif(listIndikator.filter(item => item.desa === true))
              setShowProvinsi(false)
              setShowKabupaten(false)
              setShowKecamatan(false)
              setShowDesa(true)
              setShowBNBA(false)
            }
          } else {
            setInfoLabelWilayah(labelMunicipal)
            setListIndikatorAktif(listIndikator.filter(item => item.kecamatan === true))
            setShowProvinsi(false)
            setShowKabupaten(false)
            setShowKecamatan(true)
            setShowDesa(false)
            setShowBNBA(false)
          }
        } else {
          setInfoLabelWilayah(labelProvince)
          setListIndikatorAktif(listIndikator.filter(item => item.kabupaten === true))
          setShowProvinsi(false)
          setShowKabupaten(true)
          setShowKecamatan(false)
          setShowDesa(false)
          setShowBNBA(false)
        }
      } else {
        var coord = [10576432.203633543, -1232970.377072403, 15698207.799929712, 677753.767059113]
        var xmin = coord[0]
        var ymin = coord[1]
        var xmax = coord[2]
        var ymax = coord[3]

        setZoomToMap([[[xmin, ymax], [xmin, ymin], [xmax, ymin], [xmax, ymax], [xmin, ymax]]])
        setInfoLabelWilayah('Indonesia')
        setListIndikatorAktif(listIndikator.filter(item => item.provinsi === true))
        setShowProvinsi(true)
        setShowKabupaten(false)
        setShowKecamatan(false)
        setShowDesa(false)
        setShowBNBA(false)
      }
    } else {
      alert('Pilih Indikator terlebih dahulu..')
    }
    //alert('oke')
    /*
    if (idCountry > 0) {
        if (idProvince > 0) {
            if (idMunicipal > 0) {
                const requestOptions = {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                };
  
                //props.setShowArea(true)
                fetch(url_get_municipal + idMunicipal, requestOptions).then(res => res.json()).then(data => {
  
                    if (data.status === "ok") {
                        //console.log(data.message);
                        setLabelArea(localLabelArea);
                        var bbox = JSON.parse(data.message.bbox);
                        var geom = JSON.parse(data.message.geom);
  
                        //console.log(bbox.coordinates[0][0][0])
                        var center = JSON.parse(data.message.center);
                        console.log(center.coordinates)
                        setBbox([bbox.coordinates[0][0][0], bbox.coordinates[0][0][1], bbox.coordinates[0][2][0], bbox.coordinates[0][2][1]])
                        //props.setBboxLabel('[' + bbox.coordinates[0][0][0].toFixed(2) + ', ' + bbox.coordinates[0][0][1].toFixed(2) + ', ' + bbox.coordinates[0][2][0].toFixed(2) + ', ' + bbox.coordinates[0][2][1].toFixed(2) + ']')
                        setBoundary(geom)
                        setZoomBbox(true)
                        setVisibleBoundary(true)
                        setVisibleBbox(true)
                        //props.setBboxGeom([center, geom, 2]);
  
  
                    }
  
                });
            } else {
                const requestOptions = {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                };
  
                //alert('aaa')
                //props.setShowArea(true)
                fetch(url_get_province + idProvince, requestOptions).then(res => res.json()).then(data => {
                    if (data.status === "ok") {
                        //console.log(data.message);
                        //props.setAreaName(areaLabel)
                        setLabelArea(localLabelArea);
                        var bbox = JSON.parse(data.message.bbox);
                        var center = JSON.parse(data.message.center);
  
                        var geom = JSON.parse(data.message.geom);
                        //console.log(bbox.coordinates[0][0][0])
                        setBbox([bbox.coordinates[0][0][0], bbox.coordinates[0][0][1], bbox.coordinates[0][2][0], bbox.coordinates[0][2][1]])
                        //props.setBboxLabel('[' + bbox.coordinates[0][0][0].toFixed(2) + ', ' + bbox.coordinates[0][0][1].toFixed(2) + ', ' + bbox.coordinates[0][2][0].toFixed(2) + ', ' + bbox.coordinates[0][2][1].toFixed(2) + ']')
                        setBoundary(geom)
                        setZoomBbox(true)
                        setVisibleBoundary(true)
                        setVisibleBbox(true)
                        //props.setPerformZoom(true)
                        //props.setBboxGeom([center, geom, 1]);
                    }
  
                });
  
            }
        } else {
            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            };
  
            //alert('aaa')
            //props.setShowArea(true)
            fetch(url_get_country + idCountry, requestOptions).then(res => res.json()).then(data => {
                if (data.status === "ok") {
                    //console.log(data.message);
                    //props.setAreaName(areaLabel)
                    setLabelArea(localLabelArea);
                    var bbox = JSON.parse(data.message.bbox);
                    var center = JSON.parse(data.message.center);
  
                    var geom = JSON.parse(data.message.geom);
                    //console.log(bbox.coordinates[0][0][0])
  
                    setBbox([bbox.coordinates[0][0][0], bbox.coordinates[0][0][1], bbox.coordinates[0][2][0], bbox.coordinates[0][2][1]])
                    //props.setBboxLabel('[' + bbox.coordinates[0][0][0].toFixed(2) + ', ' + bbox.coordinates[0][0][1].toFixed(2) + ', ' + bbox.coordinates[0][2][0].toFixed(2) + ', ' + bbox.coordinates[0][2][1].toFixed(2) + ']')
                    setBoundary(geom)
                    setZoomBbox(true)
                    setVisibleBoundary(true)
                    setVisibleBbox(true)
                    //props.setPerformZoom(true)
                    //props.setBboxGeom([center, geom, 1]);
                }
  
            });
        }
    } else {
        setLabelArea("Indonesia")
        setBbox([10576432.203633543, -1232970.377072403, 15698207.799929712, 677753.767059113])
        setZoomBbox(true)
        setVisibleBoundary(true)
        setVisibleBbox(true)
        //props.setBboxLabel('[-133044556.25, -20037508.34, 133044555.80, 20037508.35]');
        //props.setCountry()
        //props.setPerformZoom(true)
        //props.setBboxGeom([{ type: "Point", coordinates: [60, -2] }, { type: "Polygon", coordinates: [[[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]]] }, 0]);
    }
    */
  }

  function closeMenuIndikator() {
    var legendContainer = document.getElementById('indikatorContainer');
    var legendContent = document.getElementById('indikatorContent');
    if (collapsedIndikator) {
      legendContainer.style.width = "300px";
      legendContainer.style.height = "200px";
      setCollapsedIndikator(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "250px";
      legendContainer.style.height = "30px";
      setCollapsedIndikator(true);
      legendContent.style.display = 'none';
    }

  }

  function closeMenuStudyArea() {
    var legendContainer = document.getElementById('studyAreaContainer');
    var legendContent = document.getElementById('studyAreaContent');
    if (collapsedStudyArea) {
      legendContainer.style.width = "300px";
      legendContainer.style.height = "310px";
      setCollapsedStudyArea(false)
      setTimeout(function () {
        legendContent.style.display = 'flex';
      }, 500)
    } else {
      legendContainer.style.width = "180px";
      legendContainer.style.height = "30px";
      setCollapsedStudyArea(true);
      legendContent.style.display = 'none';
    }

  }

  function closeMenuLegend() {
    var legendContainer = document.getElementById('legendContainer');
    var legendContent = document.getElementById('legendContent');
    if (collapsedLegenda) {
      legendContainer.style.width = "260px";
      legendContainer.style.height = "auto";
      setCollapsedLegenda(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "140px";
      legendContainer.style.height = "30px";
      setCollapsedLegenda(true);
      legendContent.style.display = 'none';
    }

  }

  function closeMenuInformation() {
    var legendContainer = document.getElementById('informationContainer');
    var legendContent = document.getElementById('informationContent');
    if (collapsedInformation) {
      legendContainer.style.width = "260px";
      legendContainer.style.height = "260px";
      setCollapsedInformation(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "150px";
      legendContainer.style.height = "30px";
      setCollapsedInformation(true);
      legendContent.style.display = 'none';
    }

  }
  function closeMenuDiagram() {
    var legendContainer = document.getElementById('diagramContainer');
    var legendContent = document.getElementById('diagramContent');
    if (collapsedDiagram) {
      legendContainer.style.width = "260px";
      setCollapsedDiagram(false)
      setTimeout(function () {
        legendContent.style.display = 'block';
      }, 500)
    } else {
      legendContainer.style.width = "105px";
      setCollapsedDiagram(true);
      legendContent.style.display = 'none';
    }

  }


  //<Close fontSize="small" onClick={() => closeMenu()} />
  //ExpandMore

  function load_legend_wms() {
    if (typeof (mapLayer) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (mapLayer !== null) {

        if (mapLayer.length > 0) {
          var rev = [...mapLayer].reverse();
          return rev.map((row, index) => {
            // console.log(row)
            //console.log(row.layer)
            //Config.proxy_domain +
            if (row.tipe === "wms") {
              //alert('main')
              //Config.proxy_domain + 
              if (row.server === 'geoserver' && row.visible) {
                var wmsSource = new ImageWMSSource({
                  url: row.url,
                  params: { 'LAYERS': row.layer },
                  ratio: 1,
                  serverType: row.server,
                  crossOrigin: 'Anonymous'
                });

                //var resolution = peta.getView().getResolution();
                //console.log(resolution)
                var graphicUrl = wmsSource.getLegendUrl();
                var source ="";
                if (row.value == 0){
                  source = "PK 2021";
                }else if (row.value == 1){
                  source = "Verval 2022";
                } else if (row.value == 2){
                  source = "PK 2022";
                }

                return (<div key={index} style={{ fontSize: '12px' }}>
                  <b>{row.title} ({row.tag}, {source})</b>
                  <br />
                  <img src={Config.proxy_domain + graphicUrl} alt={row.title} />
                </div>
                )
              } else if (row.server === 'esri' && row.visible) {
                //https://geoservices.big.go.id/raster/rest/services/IMAGERY/FU_1988_Meulaboh/ImageServer/legend?bandIds=&renderingRule=&f=pjson
                if (row.url.includes("ImageServer")) {
                  var url_replace = row.url + "/legend?f=pjson";
                  //console.log(url_replace)
                  //var src = 'https://geoservices.big.go.id/rbi/rest/services/HIDROGRAFI/GARISPANTAI_50K_2021/MapServer/0/images/208cf6314143ad5675accb3a37e0ca81';
                  get_src_image(url_replace, index);

                  return (<div key={index} style={{ fontSize: '12px' }}>
                    <b>{row.title}</b>
                    <br />
                    <div id={"img-" + index} alt={row.title} />
                  </div>
                  )
                } else {

                  var url_replace = row.url + "/legend?f=pjson";
                  //var src = 'https://geoservices.big.go.id/rbi/rest/services/HIDROGRAFI/GARISPANTAI_50K_2021/MapServer/0/images/208cf6314143ad5675accb3a37e0ca81';
                  get_src(url_replace, index);

                  return (<div key={index} style={{ fontSize: '12px' }}>
                    <b>{row.title}</b>
                    <br />
                    <div id={"img-" + index} alt={row.title} />
                  </div>
                  )
                }
                //<img id={"img-" + index} alt={row.title} />

              }
            } else if (row.tipe === 'zip' && row.visible) {

              if (row.geom === 'Point') {
                return (<div key={index} style={{ fontSize: '12px' }}>
                  <b>{row.title}</b>
                  <br />

                  <div style={{ width: "10px", height: "10px", borderRadius: "50%", border: '1px solid #ccc', borderColor: '#49a5d2', backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>

                  </div>
                </div>
                )
              } else if (row.geom === 'LineString') {
                return (<div key={index} style={{ fontSize: '12px' }}>
                  <b>{row.title}</b>
                  <br />

                  <div style={{ marginTop: '9.5px', marginBottom: '9.5px', width: "20px", height: "1px", border: '0.5px solid #49a5d2', borderColor: '#49a5d2', backgroundColor: '#49a5d2' }}>

                  </div>
                </div>
                )
              }
              else {
                return (<div key={index} style={{ fontSize: '12px' }}>
                  <b>{row.title}</b>
                  <br />

                  <div style={{ width: "20px", height: "20px", border: '1px solid #ccc', borderColor: '#49a5d2', backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>

                  </div>
                </div>
                )
              }


            }

            /*
            var wmsSource = new ImageWMSSource({
                url:  row.url,
                params: { 'LAYERS': row.layer },
                ratio: 1,
                serverType: row.server,
                crossOrigin: 'Anonymous'
            });

            //var resolution = peta.getView().getResolution();
            //console.log(resolution)
            var graphicUrl = wmsSource.getLegendUrl(props.resolution);
            //console.log(graphicUrl)


            if (row.layer) {
                //<img src={main + "?" + request} alt="alt" />
                return <Row className="mr-0" key={index}>
                    <Col xs={10} className="ml-2 mt-1 font-11"><b>{row.title}</b>
                        <br />
                        <img crossOrigin="Anonymous" referrerPolicy="origin" src={graphicUrl} alt={row.title} onLoad={() => { console.log(this) }} />
                    </Col>
                </Row>
            } else {
                if (row.tipe === 'zip') {
                    return <Row className="mr-0" key={index}>
                        <Col xs={10} className="ml-2 mt-1 font-11"><b>{row.title}</b> <br />
                            <div className="border bg-light border-primary" style={{ width: "20px", height: "20px" }}>

                            </div>
                        </Col>
                    </Row>
                } else {
                    return null
                }
            }
            */
          })
        } else {
          return <span>{'belum ada legenda'}</span>
          //return create_legenda_point('Persentase Keluarga Beresiko Stunting', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['Tidak Miskin', 'Keluarga Berisiko Stunting', 'Miskin', 'Keluarga Berisiko Stunting Miskin'])

        }
      } else {
       return <span>{'belum ada legenda'}</span>
       //return create_legenda_point('Persentase Keluarga Beresiko Stunting', ['#9bc31d', '#f4d53c', '#e68d0f', '#cb151a'], ['Tidak Miskin', 'KRS', 'Miskin', 'KRS Miskin'])

      }
    } else {
      return <span>{'belum ada legenda'}</span>
    }
  }


  function create_legenda(title, color, label) {
    return (
      <div style={{ fontSize: '12px' }}>
        <b>{title}</b>
        {color.map((row, index) => {
          return (
            <div key={index} style={{ display: 'flex', marginTop: '3px' }}>
              <div style={{ width: "15px", height: "15px", border: `1px solid ${row}`, backgroundColor: `${row}` }}>
              </div>
              <span style={{ marginLeft: '5px' }}>{label[index]}</span>
            </div>
          )
        })}
      </div>
    )
  }

  function create_legenda_point(title, color, label) {
    return (
      <div style={{ fontSize: '12px' }}>
        <b>{title}</b>
        {color.map((row, index) => {
          return (
            <div key={index} style={{ display: 'flex', marginTop: '3px' }}>
              <div style={{ width: "8px", height: "8px", borderRadius: "8px", border: `1px solid ${row}`, backgroundColor: `${row}` }}>
              </div>
              <span style={{ marginLeft: '5px' }}>{label[index]}</span>
            </div>
          )
        })}
      </div>
    )
  }

  function get_src(url, index) {
    
    const requestOptions = {
      method: 'GET'
    };
    fetch(url, requestOptions).then(res => res.json()).then(data => {
      //console.log(data);
      if (data.error) {
        var div = document.getElementById('img-' + index);
        div.innerHTML = '<span>'+ data.error.message+'</span>'
      } else {
        var content = ""; 
        data?.layers?.forEach(layer => {
          //console.log(layer);
          content += layer.layerName + " ("+layer.layerId+")<br/>";
          layer.legend.forEach(legend => {
            //console.log(legend)
            content += "<img src=\"data:"+legend.contentType +";base64,"+legend.imageData +"\" alt="+ legend.label +"> <span>"+legend.label+"</span><br/>"
            
          })
        })
        var div = document.getElementById('img-' + index);
        div.innerHTML = content;
      }


    });
  
   
  }


  function get_src_image(url, index) {

    const requestOptions = {
      method: 'GET'
    };
    /*
    <table>
<tbody><tr valign="middle">
<td><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAAAAAAAAAHqZRakAAAANUlEQVQ4jWPMy8v7z0BFwMLAwMAwcdIkqhiWn5fHwEQVk5DAqIGjBo4aOGrgqIEQwEjtKgAATl0Hu6JrzFUAAAAASUVORK5CYII=" alt="Red: Band_1"></td>
<td>Red: Band_1</td>
</tr>
<tr valign="middle">
<td><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAAAAAAAAAHqZRakAAAANUlEQVQ4jWPMy8v7z0BFwMLAwMAwaeIkqhiWl5/HwEQVk5DAqIGjBo4aOGrgqIEQwEjtKgAATl0Hu6sKxboAAAAASUVORK5CYII=" alt="Green: Band_2"></td>
<td>Green: Band_2</td>
</tr>
<tr valign="middle">
<td><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAAAAAAAAAHqZRakAAAANUlEQVQ4jWPMy8v7z0BFwMLAwMAwadJEqhiWl5fPwEQVk5DAqIGjBo4aOGrgqIEQwEjtKgAATl0Hu75+IUcAAAAASUVORK5CYII=" alt="Blue: Band_3"></td>
<td>Blue: Band_3</td>
</tr>
</tbody></table>
    */
    fetch(url, requestOptions).then(res => res.json()).then(data => {
      console.log(data);
      if (data.error) {
        var div = document.getElementById('img-' + index);
        div.innerHTML = '<span>'+ data.error.message+'</span>'
      } else {
        var content = ""; 
        data?.layers?.forEach(layer => {
          console.log(layer);
          layer.legend.forEach(legend => {
            console.log(legend)
            content += "<img src=\"data:"+legend.contentType +";base64,"+legend.imageData +"\" alt="+ legend.label +"> <span>"+legend.label+"</span><br/>"
            /*var tr = document.createElement('tr');   
  
            var td1 = document.createElement('td');
            var td2 = document.createElement('td');
        
            var text1 = document.createTextNode('Text1');
            var text2 = document.createTextNode(legend.label);
        
            td1.appendChild(text1);
            td2.appendChild(text2);
            tr.appendChild(td1);
            tr.appendChild(td2);
        
            table.appendChild(tr);
            */
          })
        })
        var div = document.getElementById('img-' + index);
        div.innerHTML = content;
      }


    });
    //return src;
  }


  return (
    <Map center={fromLonLat(center)} zoom={zoom} basemap={basemap} >
      <ButtonContainer id="buttonContainer">
        <ButtonGroup disableElevation variant="contained" color="primary">
          <Button color="primary" startIcon={<LayersRounded />} size="small" onClick={() => setShowBasemap(true)}>Basemap</Button>
        </ButtonGroup>

      </ButtonContainer>
      <LegendContainer id="legendContainer">
        <Closer>
          <Title>Legenda</Title>
          <IconButton id="icon" size="small" onClick={() => closeMenu()}>
            {icon}
          </IconButton>
        </Closer>
        <LegendContent id="legendContent">
          {
            load_legend_wms()
          }
        </LegendContent>
      </LegendContainer>
      <BatasContainer id="batasContainer">
        <Closer>
          <Title>Batas Administrasi</Title>
          <IconButton id="icon" size="small" onClick={() => closeBatas()}>
            {iconBatas}
          </IconButton>
        </Closer>
        <BatasContent id="batasContent">
        <List>
        <ListItem key={1} role={undefined} dense button style={{ paddingLeft: '15px' }}>
              <ListItemIcon style={{ minWidth: '16px' }}>
                <Checkbox
                  edge="start"
                  checked={visibleBatasProvinsi}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 'checkbox-batas-provinsi' }}
                  onClick={() => setVisibleBatasProvinsi(!visibleBatasProvinsi)}
                />
              </ListItemIcon>
              <ListItemText primary="Provinsi" style={{ fontSize: '10px', maxWidth: '185px' }} />
            
            </ListItem>
            <ListItem key={2} role={undefined} dense button style={{ paddingLeft: '15px' }}>
              <ListItemIcon style={{ minWidth: '16px' }}>
                <Checkbox
                  edge="start"
                  checked={visibleBatasKabupaten}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 'checkbox-batas-kabupaten' }}
                  onClick={() => setVisibleBatasKabupaten(!visibleBatasKabupaten)}
                />
              </ListItemIcon>
              <ListItemText primary="Kabupaten" style={{ fontSize: '10px', maxWidth: '185px' }} />
            
            </ListItem>
            <ListItem key={3} role={undefined} dense button style={{ paddingLeft: '15px' }}>
              <ListItemIcon style={{ minWidth: '16px' }}>
                <Checkbox
                  edge="start"
                  checked={visibleBatasKecamatan}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 'checkbox-batas-kecamatan' }}
                  onClick={() => setVisibleBatasKecamatan(!visibleBatasKecamatan)}
                />
              </ListItemIcon>
              <ListItemText primary="Kecamatan" style={{ fontSize: '10px', maxWidth: '185px' }} />
            
            </ListItem>
            <ListItem key={4} role={undefined} dense button style={{ paddingLeft: '15px' }}>
              <ListItemIcon style={{ minWidth: '16px' }}>
                <Checkbox
                  edge="start"
                  checked={visibleBatasDesa}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 'checkbox-batas-desa' }}
                  onClick={() => setVisibleBatasDesa(!visibleBatasDesa)}
                />
              </ListItemIcon>
              <ListItemText primary="Desa" style={{ fontSize: '10px', maxWidth: '185px' }} />
            
            </ListItem>
      
            </List>
        </BatasContent>
      </BatasContainer>
      <Basemap basemap={basemap} setBasemap={setBasemap} open={showBasemap} handleCloseBasemap={(e) => handleCloseBasemap(e)} />
      <ZoomToMap zoomToMap={zoomToMap} setZoomToMap={(e) => setZoomToMap(e)} setShow={(e) => setShow(e)} />
      <PopUp coordinate={coordinate} layer={layer} show={show} content={content}
        setShow={(e) => setShow(e)} level={level} setLevel={(e) => setLevel(e)}
        kode={kode} setIdProvince={(e) => setIdProvince(e)}
        setIdMunicipal={(e) => setIdMunicipal(e)}
        setIdKecamatan={(e) => setIdKecamatan(e)}
        setIdDesa={(e) => setIdDesa(e)}
        list={list}
      />
      <Layers>
        <BasemapLayer
          basemap={basemap}
          zIndex={0}
        />
        
        {
        /*
        <IndikatorLayer zIndex={12} url={url} setShow={(e) => setShow(e)}
          setCoordinate={(e) => setCoordinate(e)} setContent={(e) => setContent(e)}
          layer={layer} level={level} setKode={(e) => setKode(e)}
        />
        */
        }
        <GroupLayer zIndex={11} mapLayer={mapLayer} identifierDelete={identifierDelete} setIdentifierDelete={setIdentifierDelete} />
        <BatasProvinsiLayer zIndex={12}  visible={visibleBatasProvinsi} />
        <BatasKabupatenLayer zIndex={13} visible={visibleBatasKabupaten} />
        <BatasKecamatanLayer zIndex={14} visible={visibleBatasKecamatan} />
        <BatasDesaLayer zIndex={15} visible={visibleBatasDesa} />
        <GraticuleLayer zIndex={16} />
        { false && <KabupatenLayer zIndex={17} visible={true} layer="resiko" kode={idProvince} />}
        { false && <KecamatanLayer zIndex={17} visible={true} layer="resiko" kode={idMunicipal} />}
        {  false && <DesaLayer zIndex={14} visible={level == 'desa'} flag={flag} setFlag={(e) => setFlag(e)} />}
        { false && <BNBALayer zIndex={15} visible={true} layer="resiko" kode={idDesa} />}
        {
          /*
          <KecamatanLayer zIndex={17} visible={true} layer="resiko" kode={idMunicipal} />
        
          
          {showProvinsi && <ProvinsiLayer zIndex={12} visible={true} layer={layer} />}
          {showKabupaten && <KabupatenLayer zIndex={13} visible={true} layer={layer} kode={idProvince} />}
          {showKecamatan && <KecamatanLayer zIndex={14} visible={true} layer={layer} kode={idMunicipal} />}
          {showDesa && <DesaLayer zIndex={14} visible={true} layer={layer} kode={idKecamatan} />}
          {showBNBA && <BNBALayer zIndex={15} visible={true} layer={layer} kode={idDesa} />}
          */
        }
        {
          //showKabupaten && <KabupatenLayer zIndex={12} visible={true} /> }
          // { //showKecamatan && <KecamatanLayer zIndex={12} visible={true} /> }
          //   { //showDesa && <DesaLayer zIndex={12} visible={true} /> }
        }
        {
          /*
          
          
          <BoundaryLayer zIndex={9} visible={visibleBoundary} boundary={boundary} />
          <BBoxLayer zIndex={10} visible={visibleBbox} bbox={bbox} zoomBbox={zoomBbox} setZoomBbox={setZoomBbox} />
          <StatisticLayer zIndex={12} visible={visibleStatistic} />
          <AnalysisLayer zIndex={13} visible={visibleAnalysis} buffered={buffered} />
          */
        }
        {
          /*
  
           <GroupLayer zIndex={11} />
  
          {showLayerStats && (
              <StatistikLayer
                source={vector({ features: new GeoJSON().readFeatures(geojsonObject, { featureProjection: get('EPSG:3857') }) })}
                style={styles.MultiPolygon}
              />
            )}
          <BBoxLayer zIndex={10} visible={true} bbox={bbox} />
          
          <GraticuleLayer />
          showLayer1 && (
              <VectorLayer
                source={vector({ features: new GeoJSON().readFeatures(geojsonObject, { featureProjection: get('EPSG:3857') }) })}
                style={styles.MultiPolygon}
              />
            )}
            {showLayer2 && (
              <VectorLayer
                source={vector({ features: new GeoJSON().readFeatures(geojsonObject2, { featureProjection: get('EPSG:3857') }) })}
                style={styles.MultiPolygon}
              />
              
              <Button color="primary" startIcon={<PrintIcon />} size="small" onClick={() => setShowPrint(true)}>Print Map</Button>
             <FullScreenControl />
            
          <GraticuleControl />
            )
             <IdentifyLayer zIndex={102} />
            */
        }

      </Layers>
      <Controls>
       
        <ZoomToExtentControl />
        <GraticuleControl />
        <ScaleLineControl />
        
        {
        /*

        <ZoomControl />
        <OverviewMapControl basemap={basemap} />
        <AttributionControl />
        */
        }
      </Controls>
      <Interactions>
        {
          /*
          <DrawBbox drawing={drawing} setBbox={setBbox} setDrawing={setDrawing} setVisibleBbox={setVisibleBbox} setLabelArea={setLabelArea} />
          */
        }
      </Interactions>

    </Map>
  )
}

const LabelContainer = styled.div`
    position: fixed;
    z-index: 1;
    top: 80px;
    text-align: center;
    right: 25%;
    left: 25%;
    width: 50%;
    color: black;
    background-color: rgba(255,223,207, 0.85);
    border: 1px solid rgba(222, 222, 255, 0.85);
    height: 25px;
    padding: 10px 10px 10px 10px;
    transition: all 0.6s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;

const IndikatorContainer = styled.div`
    position: absolute;
    left: 10px;
    top: 80px;
    z-index:1;
    color: black;
    width:300px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 130px;
    padding: 5px 10px 10px 10px;
    transition: all 0.6s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;

const StudyAreaContainer = styled.div`
    position: absolute;
    left: 10px;
    bottom: 30px;
    z-index:1;
    color: black;
    width:300px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 310px;
    padding: 5px 10px 10px 10px;
    transition: all 0.6s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;
/*
const LegendContainer = styled.div`
    position: absolute;
    right: 10px;
    bottom: 30px;
    z-index:1;
    color: black;
    width:260px;
    height: auto;
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    padding: 5px 10px 10px 10px;
    transition: all 0.8s;
    border-radius:10px;
`;
*/
const ButtonContainer = styled.div`
    position: absolute;
    z-index:1;
    left: 50px;
    bottom: 50px;
    color: white;
    transition: 0.8s;
    padding-top: 5px;
`;

const LegendContainer = styled.div`
    position: absolute;
    right:0;
    z-index:1;
    color: black;
    width:200px; 
    background-color: white;
    margin-top: 126px;
    margin-right: 50px;
    padding:5px;
    border: 1px solid #eee;
    height: 200px;
    transition: all 0.8s;
`;

const BatasContainer = styled.div`
    position: absolute;
    left:0;
    z-index:99;
    color: black;
    width:200px; 
    background-color: white;
    margin-top: 81px;
    margin-left: 50px;
    padding:5px;
    border: 1px solid #eee;
    height: 250px;
    transition: all 0.8s;
`;

const InfoContainer = styled.div`
    position: absolute;
    right: 10px;
    top: 80px;
    z-index:1;
    color: black;
    width:260px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 260px;
    padding: 5px 10px 10px 10px;
    transition: all 0.8s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;

const DiagramContainer = styled.div`
    position: absolute;
    right: 10px;
    bottom: 30px;
    z-index:1;
    color: black;
    width:260px; 
    background-color: rgba(255,255,255, 0.85);
    border: 1px solid #eee;
    height: 210px;
    padding: 5px 10px 10px 10px;
    transition: all 0.8s;
    display: flex;
    flex-direction: column;
    border-radius:10px;
`;


const AtributContainer = styled.div`
  position: fixed;
  bottom: 0;
  text-align: center;
  right: 20%;
  left: 20%;
  width: 60%;
  background: rgba(255,255,255,0.2);
  border-radius: 10px 10px 0 0;
`;
/*
const ButtonContainer = styled.div`
    position: absolute;
    z-index:1;
    margin-left: 350px;
    margin-top: 15px;
    color: white;
    transition: 0.8s;
`;
*/

const Title = styled.h3`
  margin:0px;
  color:#2F4E6F;
`;

const TitleLabel = styled.span`
  color:#2F4E6F;
  font-size:14px;
  font-weight: bold;
`;

const Value = styled.h3`
  margin:0px;
  color:#89c6e5;
`;

const Closer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 10px;
`;

const LegendContent = styled.div`
  margin-top:10px;
  max-height: 155px;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 260px;
`;
const BatasContent = styled.div`
  margin-top:0px;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 260px;
`;

const StatistikLegendContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;
const StatistikLabel = styled.div`

`;

const Box1 = styled.div`
  border: 1px solid #ccc;
  background-color:#ffffff;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box2 = styled.div`
  border: 1px solid #ccc;
  background-color: #ffbfbf;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box3 = styled.div`
  border: 1px solid #ccc;
  background-color: #ff8080;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box4 = styled.div`
  border: 1px solid #ccc;
  background-color: #ff4040;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;
const Box5 = styled.div`
  border: 1px solid #ccc;
  background-color: #ff0000;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 3px;
`;